import { render, staticRenderFns } from "./PriceExplaination.vue?vue&type=template&id=11c6b217&scoped=true"
var script = {}
import style0 from "./PriceExplaination.vue?vue&type=style&index=0&id=11c6b217&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c6b217",
  null
  
)

export default component.exports